import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_484: DocMigration = {
  maxSchemaVersion: "0.0.484",
  description:
    "Remove MINI_FASCIA_TRIM, CORNERBOARD, GABLE_FULL_RETURN_ROOF, and RAFTER_EXTENSION_CAP from ViewNoteSettings",
  apply(json: any): any {
    if (!json.settings) {
      return json;
    }

    const removedFields = ["MINI_FASCIA_TRIM", "CORNERBOARD", "GABLE_FULL_RETURN_ROOF", "RAFTER_EXTENSION_CAP"];

    // Iterate through all settings to find VIEW_NOTE_SETTINGS
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];

      // Check if this is a VIEW_NOTE_SETTINGS object
      if (setting?.type === "VIEW_NOTE_SETTINGS") {
        // Remove obsolete fields from this settings object
        for (const field of removedFields) {
          if (setting[field] !== undefined) {
            delete setting[field];
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_484;
